// French elides "de" before a vowel sound: "l'histoire d'Antoine", but
// "l'histoire de Léa". A leading "h" is left alone: whether it is muet
// depends on the name, and "de Hugo" is never wrong.
const VOWEL = /^[aeiouyàâäéèêëîïôöùûüœæ]/iu;

export function withDe(name: string): string {
  const trimmed = name.trim();
  return VOWEL.test(trimmed) && !/^y[aeiouàâäéèêëîïôöùûü]/iu.test(trimmed)
    ? `d'${trimmed}`
    : `de ${trimmed}`;
}
